
/* eslint-disable */
'use strict'

// https://blog.bitsrc.io/understanding-mixins-in-vue-js-bdcf9e02a7c1
// https://codereview.stackexchange.com/questions/128587/check-if-images-are-loaded-es6-promises

export default {
  data() {
    return {
      hasYoutube: false,
      hasRun: false
    }
  },
  methods: {
    checkYoutube: async function () {
      // this.hasRun = true
      let path = location.protocol + "//www.youtube.com/favicon.ico";
      let aout = new Promise( resolve => {
        const img = new Image();
        img.onload = () => resolve({ hasYoutube: true, hasRun: true });
        img.onerror = () => resolve({ hasYoutube: false, hasRun: true });
        img.src = path;
      })
      return aout
    }
  },
  async created() {
    // console.log(`youtubeMixin created`)
  },
  mounted() {
    // console.log(`youtubeMixin mounted`)
  },
};


// WEBPACK FOOTER //
// ./src/plugins/youtubeMixin.js